import React, { useState, useRef, useEffect } from "react";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/EditOutlined";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import TooltipText from "../common/tooltipText";
import "../../styles/admin/courseCard.scss";
import "../../styles/admin/institutionCourseCard.scss";
import CoursePublishPopup from "../common/CoursePublishPopup";
import { PublishRounded } from "@mui/icons-material";
import SuccessPopup from "../common/SuccessPopup";
import Cookies from "js-cookie";
const CourseCard = ({
  course,
  onEdit,
  onDelete,
  hideActionBtn,
  fetchCourses,
  handleNavigate,
  preferenceStatus = false,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);
  const [showPublishPopup, setShowPublishPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const role = Cookies.get("role");
  const boardName = course?.board?.name || course?.board || "";
  const className =
    course?.class_name?.name ||
    course?.class_name ||
    course?.class?.name ||
    course?.class ||
    "";

  const handleClick = (e) => {
    if (showMenu) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    if (
      e.target.closest(".course-actions") ||
      e.target.closest(".course-actions-menu")
    ) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    handleNavigate();
  };

  const handleMenuToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu(!showMenu);
  };

  const handleEdit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu(false);
    onEdit && onEdit(course);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu(false);
    onDelete && onDelete(course);
  };

  const handlePublish = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu(false);
    setShowPublishPopup(true);
  };

  const handlePublishConfirm = (selection) => {
    setShowPublishPopup(false);
  };

  const formatDateTime = (dt) => {
    if (!dt) return "--";
    try {
      const d = new Date(dt);
      if (Number.isNaN(d.getTime())) return String(dt);
      return d.toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (e) {
      return String(dt);
    }
  };

  const handleOnclose = async () => {
    setShowSuccessPopup(false);
    await fetchCourses();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  return (
    <>
      {showPublishPopup && (
        <CoursePublishPopup
          open={showPublishPopup}
          onClose={() => setShowPublishPopup(false)}
          onConfirm={handlePublishConfirm}
        />
      )}
      <div className="course-card" onClick={handleClick}>
        <div className="course-card-title-container">
          <div className="course-card-heading">
            <div className="course-card-title">
              <span className="course-title-text">
                {course?.name || "Untitled Course"}
              </span>
            </div>
            {/* {(boardName || className) && (
              <div className="course-card-chips">
                {boardName && (
                  <span className="course-chip board-chip">
                    <span className="chip-label">Board:</span> {boardName}
                  </span>
                )}
                {className && (
                  <span className="course-chip class-chip">
                    <span className="chip-label">Class:</span> {className}
                  </span>
                )}
              </div>
            )} */}
          </div>
          {!hideActionBtn && (
            <div className="course-actions" ref={menuRef}>
              <button
                className="action-btn"
                onClick={handleMenuToggle}
                aria-haspopup="menu"
                aria-expanded={showMenu}
                aria-label="Course actions"
                type="button"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <MoreVertIcon fontSize="small" />
              </button>
              {showMenu && (
                <div
                  className="course-actions-menu"
                  role="menu"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    type="button"
                    className="actions-item"
                    onClick={handleEdit}
                    role="menuitem"
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <EditIcon fontSize="small" /> Edit
                    </span>
                  </button>
                  <button
                    type="button"
                    className="actions-item danger"
                    onClick={handleDelete}
                    role="menuitem"
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <DeleteIcon fontSize="small" /> Delete
                    </span>
                  </button>
                  {!course?.publish && (
                    <button
                      type="button"
                      className="actions-item"
                      role="menuitem"
                      onClick={handlePublish}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <PublishRounded fontSize="small" /> Publish
                      </span>
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
        {!preferenceStatus && (
          <div className="course-card-desc">
            <div className="course-card-status-label">Status</div>
            <div className="course-card-status-value">
              {course?.publish ? "Published" : "Not Publish "}
            </div>
          </div>
        )}
        {(boardName || className) && (
          <div className="course-card-chips">
            {boardName && (
              <span className="course-chip board-chip">
                <span className="chip-label">Board:</span> {boardName}
              </span>
            )}
            {className && (
              <span className="course-chip class-chip">
                <span className="chip-label">Class:</span> {className}
              </span>
            )}
          </div>
        )}
        <div className="course-card-times">
          <span className="time-item">
            <TooltipText
              text={`Created: ${formatDateTime(course?.created_at)}`}
              always
              fullWidth
              placement="bottom"
            />
          </span>
          {/* <span className="time-item">
            <TooltipText
              text={`Updated: ${formatDateTime(course?.updated_at)}`}
              always
              fullWidth
              placement="bottom"
            />
          </span> */}
        </div>
      </div>
      {showPublishPopup && (
        <CoursePublishPopup
          courseData={course}
          open={showPublishPopup}
          fetchCourses={fetchCourses}
          onClose={() => setShowPublishPopup(false)}
          onConfirm={handlePublishConfirm}
          setShowSuccessPopup={setShowSuccessPopup}
        />
      )}
      {showSuccessPopup && (
        <SuccessPopup
          open={showSuccessPopup}
          onClose={handleOnclose}
          message="Course published successfully!"
        />
      )}
    </>
  );
};
export default CourseCard;
